import { createAsyncThunk } from "@reduxjs/toolkit";
import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { pickupDeliveryApi } from "service/pickupDeliveryApi";

export const getPickupDelivery = createAsyncThunk(
  "pickupDelivery/getPickupDelivery",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await pickupDeliveryApi.getPickupDelivery();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updatePickupDelivery = createAsyncThunk(
  "pickupDelivery/updatePickupDelivery",
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await pickupDeliveryApi.updatePickupDelivery(body);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getPickupDelivery());
      return data;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  },
);
